<template>
	<div class="ylImageViewer image_viewer_wrapper" ref="image_viewer_wrapper">
		<!-- 背景 -->
		<div class="image_viewer_mask" @click.self="handleMaskClick"></div>
		<!-- 关闭按钮 -->
		<span class="image_viewer_btn image_viewer_close"><i class="el-icon-close" @click="hide"></i></span>
		<!-- 上一张 -->
		<span class="image_viewer_btn image_viewer_prev" @click="prev" v-if="urlList && urlList.length > 1"><i class="el-icon-arrow-left"></i></span>
		<!-- 下一张 -->
		<span class="image_viewer_btn image_viewer_next" @click="next" v-if="urlList && urlList.length > 1"><i class="el-icon-arrow-right"></i></span>
		<!-- 操作按钮 -->
		<div class="image_viewer_btn image_viewer_actions" v-show="!getFileType(imgList[index])">
			<div class="image_viewer_actions_inner">
				<i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
				<i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
				<i class="el-image-viewer__actions__divider"></i>
				<!-- <i :class="mode.icon" @click="toggleMode"></i> -->
				<i class="el-icon-download" @click="handleDownloadImg"></i>
				<i class="el-image-viewer__actions__divider"></i>
				<i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
				<i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i>
			</div>
		</div>
		<div class="image_viewer_canvas">
			<div v-for="(url, i) in imgList" v-if="i === index" :key="i" :class="[getFileType(url) ? 'w100' : '']" :style="getFileType(url) ? iframeBoxStyle : ''">
				<iframe :src="currentImg" v-if="getFileType(url)" height='100%' :style="iftameStyle"></iframe>
				<img ref="img" class="el-image-viewer__img" v-else :src="currentImg" :style="imgStyle" @load="handleImgLoad" @error="handleImgError">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'yl-lc-imageViewer',
	props: {
		urlList: {
			type: Array,
			default: () => []
		},
		// zIndex: {
		// 	type: Number,
		// 	default: 2000
		// },
		onSwitch: {
			type: Function,
			default: () => {}
		},
		onClose: {
			type: Function,
			default: () => {}
		},
		initialIndex: {
			type: Number,
			default: 0
		},
		appendToBody: {
			type: Boolean,
			default: true
		},
		maskClosable: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			iframeBoxStyle: {
				"height": "100%"
			},
			iftameStyle: {
				"height": "80%",
				"position": "relative",
				"width": "80%",
				"left": "10%",
				"top": "10%"
			},
			index: this.initialIndex,
			isShow: false,
			infinite: true,
			loading: false,
			transform: {
				scale: 1,
				deg: 0,
				offsetX: 0,
				offsetY: 0,
				enableTransition: false
			}
		};
	},
    computed: {
		// 判断是否为pdf文件
		getFileType(file){
			return (file)=>{
					if(file){
						let suffix;
						let fileName = file.name || file.showName || file.fileName || file.fileShowName
						if(fileName){
							suffix = fileName.split(".")[fileName.split(".").length - 1].toLowerCase();
						}
						let arr = file.suffix || suffix || "pdf";
						return arr == "pdf" || arr == ".pdf" || arr == ".PDF" || arr == "PDF" ? true : false
				}
			}
		},
		urlListArrObject(){
			let every = this.urlList.every(item=>{
				return typeof item == 'object'
			})
			return every
		},
		imgList(){
			let obj = {
				bizType: "",
				downLoadUrl: "",
				fileMd5: "",
				fileNo: "",
				fileSize: null,
				id: null,
				previewUrl: "",
				showName: "下载图片",
				suffix: "",
			}
			if(this.urlListArrObject){
				return this.urlList.map(item=>{
					let showName = this.bianli(item.downLoadUrl || item.downloadUrl || item.previewUrl)
					return {
						...obj,
						...item,
						showName: item.showName ? item.showName : (item.fileShowName ? item.fileShowName : showName)
					}
				})
			}else{
				return this.urlList.map(item=>{
					let showName = this.bianli(item)
					return {
						...obj,
						previewUrl: item,
						downLoadUrl: item,
						showName: showName
					}
				})
			}
		},
		isSingle() {
			return this.urlList.length <= 1;
		},
		isFirst() {
			return this.index === 0;
		},
		isLast() {
			return this.index === this.urlList.length - 1;
		},
		currentImg() {
			if(this.imgList && this.imgList.length > 0){
				return this.imgList[this.index].previewUrl;
			}
		},
		imgStyle() {
			const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
			const style = {
			transform: `scale(${scale}) rotate(${deg}deg)`,
			transition: enableTransition ? 'transform .3s' : '',
			'margin-left': `${offsetX}px`,
			'margin-top': `${offsetY}px`
			};
			// if (this.mode === Mode.CONTAIN) {
			// style.maxWidth = style.maxHeight = '100%';
			// }
			return style;
		},
    },
    watch: {
		index: {
			handler: function(val) {
				this.reset();
				this.onSwitch(val);
			}
		},
		currentImg(val) {
			this.$nextTick(_ => {
				const $img = this.$refs.img[0] || {};
				if (!$img.complete) {
					this.loading = true;
				}
			});
		}
    },
	methods:{
		bianli(path) {
			let filename;
			if (path.indexOf("/") > 0) {
				filename = path.substring(path.lastIndexOf("/") + 1, path.length);
			} else {
				filename = path;
			}
			if(filename.indexOf("?") > 0){
				filename = filename.substring(0, filename.indexOf("?"));
			}
			return filename;
		},
		handleActions(action, options = {}) {
			if (this.loading) return;
			const { zoomRate, rotateDeg, enableTransition } = {
			zoomRate: 0.2,
			rotateDeg: 90,
			enableTransition: true,
			...options
			};
			const { transform } = this;
			switch (action) {
			case 'zoomOut':
				if (transform.scale > 0.2) {
				transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
				}
				break;
			case 'zoomIn':
				transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
				break;
			case 'clocelise':
				transform.deg += rotateDeg;
				break;
			case 'anticlocelise':
				transform.deg -= rotateDeg;
				break;
			}
			transform.enableTransition = enableTransition;
		},
		handleDownloadImg(){
			if(this.imgList && this.imgList.length > 0){
				// 有下载地址的时候使用下载地址
				let downLoadUrl = this.imgList[this.index].downloadUrl || this.imgList[this.index].downLoadUrl
				if(downLoadUrl){
					window.open(downLoadUrl)
					// this.downloadImg(this.imgList[this.index].downloadUrl)
				}else{
					this.$function.LOCATION.download(this.imgList[this.index].previewUrl, this.imgList[this.index].showName+".jpg")
				}
			}
			// this.downloadImg(this.urlList[this.index].previewUrl)
		},
		downloadImg(url){
			var a = document.createElement('a');
			var event = new MouseEvent('click')
			a.download = 'beautifulGirl'
			a.href = url;
			a.dispatchEvent(event)
		},
		handleImgLoad(e) {
			this.loading = false;
		},
		handleImgError(e) {
			this.loading = false;
			e.target.alt = '加载失败';
		},
		hide(){
			this.onClose();
		},
		handleMaskClick() {
			if (this.maskClosable) {
				this.hide();
			}
		},
		prev() {
			if (this.isFirst && !this.infinite) return;
			const len = this.urlList.length;
			this.index = (this.index - 1 + len) % len;
		},
		next() {
			if (this.isLast && !this.infinite) return;
			const len = this.urlList.length;
			this.index = (this.index + 1) % len;
		},
		reset() {
			this.transform = {
				scale: 1,
				deg: 0,
				offsetX: 0,
				offsetY: 0,
				enableTransition: false
			};
		},
	},
    mounted() {
		// this.deviceSupportInstall();
		if (this.appendToBody) {
			document.body.appendChild(this.$el);
		}
		// add tabindex then wrapper can be focusable via Javascript
		// focus wrapper so arrow key can't cause inner scroll behavior underneath
		this.$refs['image_viewer_wrapper'].focus();
    },
    destroyed() {
		// if appendToBody is true, remove DOM node after destroy
		if (this.appendToBody && this.$el && this.$el.parentNode) {
			this.$el.parentNode.removeChild(this.$el);
		}
    }
};
</script>
<style lang="less">
.ylImageViewer{
	position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
	left: 0;
	z-index: 3000;
	.image_viewer_mask{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: .5;
		background: #000;
	}
	.image_viewer_btn{
		position: absolute;
		z-index: 1;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		border-radius: 50%;
		opacity: .8;
		cursor: pointer;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		user-select: none;
	}
	.image_viewer_close{
		top: 40px;
		right: 40px;
		width: 40px;
		height: 40px;
		font-size: 24px;
		color: #fff;
		background-color: #606266;
	}
	.image_viewer_prev, .image_viewer_next{
		top: 50%;
		width: 44px;
		height: 44px;
		font-size: 24px;
		color: #fff;
		background-color: #606266;
		border-color: #fff;
	}
	.image_viewer_prev{
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		left: 40px;
	}
	.image_viewer_next{
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		right: 40px;
		text-indent: 2px;
	}
	.image_viewer_actions{
		left: 50%;
		bottom: 30px;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		width: 282px;
		height: 44px;
		padding: 0 23px;
		background-color: #606266;
		border-color: #fff;
		border-radius: 22px;
		.image_viewer_actions_inner{
			width: 100%;
			height: 100%;
			text-align: justify;
			cursor: default;
			font-size: 23px;
			color: #fff;
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-align: center;
			-ms-flex-align: center;
			align-items: center;
			-ms-flex-pack: distribute;
			justify-content: space-around;
		}
	}
	.image_viewer_canvas{
		width: 100%;
		height: 100%;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}
}
</style>
